import { render, staticRenderFns } from "./ItemHistoryChangeTypeRelationshipManyToMany.vue?vue&type=template&id=8f017b2a&scoped=true"
import script from "./ItemHistoryChangeTypeRelationshipManyToMany.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeRelationshipManyToMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f017b2a",
  null
  
)

export default component.exports